/** Deploy basename (VITE_BASE_URL) без ведущих и хвостовых слэшей. */
function basePath(): string {
  return (import.meta.env.VITE_BASE_URL ?? "")
    .replace(/^\/+/, "")
    .replace(/\/+$/, "")
}

/**
 * Абсолютный путь внутри приложения с учётом basename деплоя.
 * Для полных перезагрузок мимо react-router (логаут, 401, impersonate).
 */
export function appPath(subpath: string): string {
  const base = basePath()
  const path = subpath.startsWith("/") ? subpath : `/${subpath}`
  return base ? `/${base}${path}` : path
}
